import { createApi } from '@reduxjs/toolkit/query/react';
import { AuthUserIF, LoginDataIF, LoginUserByTgIF } from '@/api/authApi/types';
import { UserIF } from '@/api/userApi/types';
import { fetchRestApiQuery } from '@/helpers/api';
import { getCookie } from '@/helpers/storage';
import { STORAGE_KEYS } from '@/constants/storageKeys';

export const authApi = createApi({
    reducerPath: 'authApi',
    baseQuery: fetchRestApiQuery('/Auth'),
    endpoints: (builder) => ({
        authUser: builder.mutation<LoginDataIF, AuthUserIF>({
            query: ({ email, password }) => ({
                url: '/',
                method: 'POST',
                body: {
                    username: email,
                    password,
                },
            }),
            transformResponse: (response: LoginDataIF): LoginDataIF => {
                const user = getCookie(STORAGE_KEYS.User);

                if (user && user === 'new') {
                    return { ...response, isNewUser: true };
                }

                return response;
            },
        }),
        loginUserByTg: builder.mutation<LoginDataIF, LoginUserByTgIF>({
            query: (body) => ({
                url: '/Tg',
                method: 'POST',
                body,
            }),
        }),
        getCurrentUser: builder.query<UserIF, void>({
            query: () => ({
                url: `/Me`,
            }),
        }),
    }),
});
